import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';

const TTBF001CPParams = () => {
  return (
    <div className='mx-auto w-[1440px] max-w-full lg_px-0  lg_py-5'>
      <div className='rounded-[12px] bg-white lg_rounded-[16px] lg_py-[24px]'>
        <div className='flex flex-col'>
          <div className='hidden items-center justify-start lg_flex'>
            <p className='flex items-center justify-start font-poppins text-lg text-primary'>Camera module</p>
          </div>
          <div className='mt-[16px] hidden grid-cols-4 rounded-[24px] py-[24px] lg_grid'>
            <div className='border-r-[1.5px] border-[#ccc] xl_pr-[10px] 2xl_pr-[32px]'>
              <p className='mb-2 text-[14px] font-[700] leading-[20px] text-title lg_text-[20px] lg_leading-[28px]'>
                Dimensions
              </p>
              <div className='mb-[12px] font-sans font-semibold text-[#333]'>
                <p className='flex items-center justify-between leading-[28px]'>
                  <span>Height</span>
                  <span>3.50 in / 89 mm</span>
                </p>
                <p className='flex items-center justify-between leading-[28px]'>
                  <span>Width</span>
                  <span>2.64 in / 67 mm</span>
                </p>
                <p className='flex items-center justify-between leading-[28px]'>
                  <span>Depth</span>
                  <span>2.28 in / 58 mm</span>
                </p>
              </div>
            </div>
            <div className='xl_px-[10px] 2xl_px-[32px]'>
              <p className='mb-2 text-[14px] font-[700] leading-[20px] text-title lg_text-[20px] lg_leading-[28px]'>
                Features
              </p>
              <div className='font-sans font-semibold text-[#333]'>
                <p>Camera</p>
                <p>Field of View</p>
                <p>Detection</p>
                <p>Audio</p>
                <p>Power</p>
                <p>Charging</p>
                <p>Connectivity</p>
                <p>Operating Temperature</p>
                <p>Weather resistant</p>
              </div>
            </div>
            <div className='col-span-2 xl_px-[10px] 2xl_px-[32px]'>
              <p className='mb-2 text-[14px] font-[700] leading-[20px] text-title lg_text-[20px] lg_leading-[28px]'>
                &nbsp;
              </p>
              <div className='font-sans font-semibold text-[#333]'>
                <p>2 megapixel Photos and 2 megapixel Video</p>
                <p>Diagonal 170 degrees, horizontal 135 degrees, vertical 70 degrees</p>
                <p>Passive Infrared Sensor</p>
                <p>Microphone</p>
                <p>5000mAh Rechargeable Lithium Ion Battery</p>
                <p>Type-C cable and two solar panel</p>
                <p>2.4 GHz </p>
                <p>14°F to 113°F (-10 ℃ to 45 ℃)</p>
                <p>Yes (IP65 Certified)</p>
              </div>
            </div>
          </div>
          <Accordion
            type='multiple'
            className='mt-5 w-full px-[17px] lg_hidden'
          >
            <AccordionItem
              value='item-4'
              className='border-y-0'
            >
              <AccordionTrigger className='font-sans text-[1.2rem] font-extrabold text-primary'>
                <h2>Camera module</h2>
              </AccordionTrigger>
              <AccordionContent>
                <div className='mt-[12px] flex flex-col lg_hidden'>
                  <p className='mb-2 text-[16px] font-[700] leading-[22px] text-title'>Dimensions</p>
                  <div className='mb-[12px] font-sans font-semibold text-[#333]'>
                    <p className='flex items-center justify-between leading-[28px]'>
                      <span>Height</span>
                      <span>3.50 in / 89 mm</span>
                    </p>
                    <p className='flex items-center justify-between leading-[28px]'>
                      <span>Width</span>
                      <span>2.64 in / 67 mm</span>
                    </p>
                    <p className='flex items-center justify-between leading-[28px]'>
                      <span>Depth</span>
                      <span>2.28 in / 58 mm</span>
                    </p>
                  </div>
                  <p className='mb-2 text-[16px] font-[700] leading-[22px] text-title'>Features</p>
                  <p className='mb-2 text-[14px] font-[700] leading-[20px] text-title'>Camera</p>
                  <p className='mb-[12px] font-sans font-semibold text-[#333]'>
                    2 megapixel Photos and 2 megapixel Video
                  </p>
                  <p className='mb-2 text-[14px] font-[700] leading-[20px] text-title'>Field of View</p>
                  <p className='mb-[12px] font-sans font-semibold text-[#333]'>
                    Diagonal 180 degrees, horizontal 150 degrees, vertical 83 degrees
                  </p>
                  <p className='mb-2 text-[14px] font-[700] leading-[20px] text-title'>Detection</p>
                  <p className='mb-[12px] font-sans font-semibold text-[#333]'>Passive Infrared Sensor</p>

                  <p className='mb-2 text-[14px] font-[700] leading-[20px] text-title'>Audio</p>
                  <p className='mb-[12px] font-sans font-semibold text-[#333]'>Microphone </p>

                  <p className='mb-2 text-[14px] font-[700] leading-[20px] text-title'>Power</p>
                  <p className='mb-[12px] font-sans font-semibold text-[#333]'>
                    5000mAh Rechargeable Lithium Ion Battery{' '}
                  </p>

                  <p className='mb-2 text-[14px] font-[700] leading-[20px] text-title'>Charging</p>
                  <p className='mb-[12px] font-sans font-semibold text-[#333]'>Type-C cable and two solar panel </p>

                  <p className='mb-2 text-[14px] font-[700] leading-[20px] text-title'>Connectivity</p>
                  <p className='mb-[12px] font-sans font-semibold text-[#333]'>2.4 GHz </p>

                  <p className='mb-2 text-[14px] font-[700] leading-[20px] text-title'>Operating Temperature</p>
                  <p className='mb-[12px] font-sans font-semibold text-[#333]'>14°F to 113°F (-10 ℃ to 45 ℃)</p>

                  <p className='mb-2 text-[14px] font-[700] leading-[20px] text-title'>Weather resistant </p>
                  <p className='mb-[12px] font-sans font-semibold text-[#333]'>Yes (IP65 Certified) </p>
                </div>
              </AccordionContent>
            </AccordionItem>
          </Accordion>
        </div>
      </div>
    </div>
  );
};

export default TTBF001CPParams;
